import { render, staticRenderFns } from "./MyStudents.vue?vue&type=template&id=f3c4b50c&scoped=true&"
import script from "./MyStudents.vue?vue&type=script&lang=js&"
export * from "./MyStudents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c4b50c",
  null
  
)

export default component.exports